import React from "react";
import { calculateDepositCharges,   calculateHireVisibilityCharges 
 } from "../../utils/calculateVisibilityCharges";

function BillComponent({
  visibilityPrice = 0,
  powerPackPrice,
  totalPrice,
  handleSubmit,
  ammount,
  maxquantity,
  saleMode,
    saleProduct, 
  hireChargeAmount = 0, 
  hireDuration = { value: 0, unit: "days" }, 
    selectedHireType = "days",
  categoryName, 

  subcategoryName, 
}) {
    //  Enhanced Debugging Logs for Props
    console.group("📌 BillComponent Props Debugging");
    console.log("🔹 Received Props:", {
      visibilityPrice,
      powerPackPrice,
      totalPrice,
      ammount,
      maxquantity,
      saleMode,
          saleProduct,
    hireChargeAmount,
    hireDuration,
      categoryName,
      subcategoryName
    });
    console.groupEnd();

    if (!categoryName || !subcategoryName) {
      console.error("❌ Error: Missing category/subcategory data.", {
        categoryName,
        subcategoryName,
        ammount,
        maxquantity,
      });

      return (
        <div className="text-red-500">
          ⚠️ Error: Unable to fetch category details. Please try again later.
        </div>
      );
    }

    // Initialize deposit amount and percentage
  let depositAmount = 0;
  let depositPercentage = 0;

  if (saleMode === "Sale By OGCS") {
    try {
      //  Call utility function for calculation
      depositAmount = calculateDepositCharges(categoryName, subcategoryName, ammount, maxquantity);
      
      console.log("💰 Calculated Deposit Amount:", depositAmount);

      //  Deposit percentage mapping
      const depositPercentages = {
        "Hand Tools": {
          "Manual Hand Tool": 6,
          "Electrical hand tool": 6,
          "Hydrolic Hand Tool": 6,
          "Electrical Hand Tool": 6, // Added missing subcategory
    
        },
        "Small Equipment": {
          "Concrete mixtures": 5,
          "Concrete Mixing Tools": 5,
          "Surveying and Measurement Tools": 5,
          "Excavation and Digging Tools": 5,
          "Compaction and Tamping Tools": 5,
          "Finishing and Smoothing Tools": 5,
          "Vibrators for Concrete": 5,
        },
        "Structural Material": {
          "Reinforcement steel": 1,
          "Hot Rolled Deformed Bars": 1,
          "Cold Rolled Steel Bars": 1,
          "Mild Steel Bars": 1,
          "Welded Steel Wire.": 1,
          "Prestressing steel bars": 1,
          "Epoxy coated rebar": 1,
          "High yield strength deformed (HYSD) bar": 1,
          "Structural steel Deferent section and size": 1,
          "Alloy steel": 1,
          "Heat-treated carbon steel": 1,
          "Heat-treated alloy steel.": 1 ,
        },
        "Bulk Material/Construction Materials": {
          "Concrete Block": 5,
          "Bricks": 5,
          "Fly Ash ": 5,
          "Bituminous Materials": 4,
          "Sand and Aggregates": 10,
          "Cement and Cement Products": 2,
        },
        "Heavy Equipment": {
          "Concrete Batching Plants": 5,
          "Forklifts and Pallet Jacks": 5,
          "Concrete Pumps": 5,
          "Boom Placers": 5,
          "Porta cabin": 5,
          "Specialized Heavy Equipment's": 5,
          "Power Trencher": 5,
          "Transport Equipment": 5,
          "Plastering and Masonry Equipment": 8.5,
          "Cranes": 8.5,
          "Concrete Equipment": 8.5,
          "Rollers": 5,
          "Excavators and Loaders": 5,
        },
        "Contruction Chemical and Materials": {
          "Concrete Hardeners": 5,
          "Waterproofing Solutions": 5,
          "Surface Treatments": 5,
          "Bonding and Adhesive Agents": 5,
          "Protective Coatings": 5,
          "Grouts and Repair Mortars": 5,
          "Admixtures for Concrete": 5,
          "Insulation Materials": 5,
          "Tiles and Pavers": 5,
          "Joints and Panels": 5,
          "Expansion Joints and Water Stoppers": 5,
          "Paint" : 3 ,
          "Fastener and Anchor" :5,
          "Nails and Screws" :5,
            },
    
        "Finishing Items": {
          "Rolling Shutters": 5,
          "Windows": 5,
          "Doors": 5,
          "Water Heaters": 5,
          "Sanitary Fixtures": 5,
          "Water Supply Fixtures": 5,
          "Valves": 5,
          "Pipe Fittings": 5,
          "Galvanized Steel Pipes": 5,
          "Copper Pipes": 5,
          "PEX Pipes (Cross-Linked Polyethylene)": 5,
          "CPVC Pipes (Chlorinated Polyvinyl Chloride)": 5,
          "PVC Pipes (Polyvinyl Chloride)": 5,
        },
        "Form Work Material": {
          "Formwork Panels (Modular)": 5,
          "wooden batten": 5,
          "Playwood": 5,
          "Additional Formwork Components": 5,
          "Doka Components": 5,
          "Cup Lock Scaffolding System": 5,
          "Access Scaffolding": 5,
          "HDT System": 5,
          "Wall/Column Formwork": 5,
          "Advanced Scaffolding Systems": 5,
          "Basic Formwork Components": 5,
        },
        "Specialized Equipment's": {
          "Dewatering pumps": 4,
          "D.G.Sets": 4,
          "Specialized Testing Equipment": 4,
          "Specialized Equipment": 4,
          "GPS and Total Stations": 4,
          "Surveying Instruments": 4,
        },
        "Safety Items": {
          "First Aid and Fire Safety Equipment": 5,
          "Fall Protection Equipment": 5,
          "Personal Protective Equipment (PPE)": 5,
        },

        
    "Electrical Materials" : {
      "Conduits and Fittings": 5,
      "Wires and Cables": 7,
      "Switches and Sockets": 7,
      "Light Fixtures": 7,
      "Distribution Boards and Protection Devices": 10,
      "Earthing and Lightning Protection": 10,
      "Control Panels and Accessories": 5,
      "Communication & Safety": 5,
      "Miscellaneous Items": 10,

    },
      };

      //  Fetch deposit percentage, default to 0 if not found
      try {
        // Call utility function for deposit calculation
        depositAmount = calculateDepositCharges(categoryName, subcategoryName, ammount, maxquantity);
        console.log("💰 Calculated Deposit Amount:", depositAmount);
      
        // Normalize subcategory name to avoid case-sensitivity issues
        const normalizedSubcategory = subcategoryName.trim().toLowerCase();
      
        // Normalize depositPercentages keys for matching
        const depositPercentagesNormalized = Object.keys(depositPercentages[categoryName] || {}).reduce((acc, key) => {
          acc[key.toLowerCase()] = depositPercentages[categoryName][key];
          return acc;
        }, {});
      
        // Fetch deposit percentage, default to 0 if not found
        depositPercentage = depositPercentagesNormalized[normalizedSubcategory] || 0;
        console.log("💰 Deposit Percentage:", depositPercentage);
      } catch (error) {
        console.error("❌ Error in deposit calculation:", error.message);
      }
      
      console.log("💰 Deposit Percentage:", depositPercentage);
    } catch (error) {
      console.error("❌ Error in deposit calculation:", error.message);
    }
  }
  // -------------------- Hire Charges --------------------
  const hireChargePerUnit = Number(hireChargeAmount) || 0;
  const hireQty = Number(maxquantity) || 0;
  const hireDurationValue = Number(hireDuration?.value) || 0;
  const hireDurationUnit = hireDuration?.unit || "days";
  const hireType = selectedHireType || "days";

  const unitConversion = () => {
    if (hireType === "days") {
      if (hireDurationUnit === "days") return hireDurationValue;
      if (hireDurationUnit === "weeks") return hireDurationValue * 7;
      if (hireDurationUnit === "months") return hireDurationValue * 30;
    }
    if (hireType === "weeks") {
      if (hireDurationUnit === "days") return hireDurationValue / 7;
      if (hireDurationUnit === "weeks") return hireDurationValue;
      if (hireDurationUnit === "months") return hireDurationValue * 4.345;
    }
    if (hireType === "months") {
      if (hireDurationUnit === "days") return hireDurationValue / 30;
      if (hireDurationUnit === "weeks") return hireDurationValue / 4.345;
      if (hireDurationUnit === "months") return hireDurationValue;
    }
    return 0;
  };

  const convertedDuration = unitConversion();

  const hireAmount =
    saleMode === "Sale By Seller" && saleProduct === "Hire"
      ? Math.round(hireChargePerUnit * hireQty * convertedDuration)
      : 0;

  console.group("🛠️ Hire Charges Debugging");
  console.log(
    `Hire Calculation: ${hireChargePerUnit} × ${hireQty} × ${convertedDuration} = ${hireAmount}`
  );
  console.groupEnd();

  // -------------------- Hire Visibility Calculation --------------------
const monthlyHireValue = hireAmount;

let correctedVisibilityPrice;

if (saleMode === "Sale By Seller" && saleProduct === "Hire") {
  correctedVisibilityPrice =
    calculateHireVisibilityCharges(monthlyHireValue, visibilityPrice === 15000
      ? '1X'
      : visibilityPrice === 19500
      ? '2X'
      : visibilityPrice === 25350
      ? '3X'
      : visibilityPrice === 32955
      ? '4X'
      : '1X');

  console.log(
    `Hire Visibility Calculation (via utility): ${monthlyHireValue} → ${correctedVisibilityPrice}`
  );
} else {
  correctedVisibilityPrice = visibilityPrice;
}




// const totalAmountBeforeGST = visibilityPrice + powerPackPrice + hireAmount;

//     const gstPercentage = 18;
//     const gstAmount = Math.round(totalAmountBeforeGST * (gstPercentage / 100));
  
//     // Final total amount including GST
//     const totalAmountWithGST = totalAmountBeforeGST + gstAmount;

//     const finalTotalAmount = saleMode === "Sale By OGCS" ? totalAmountWithGST + depositAmount : totalAmountWithGST; ;
  // -------------------- GST and Total Calculation --------------------
  const totalAmountBeforeGST =
    correctedVisibilityPrice + powerPackPrice ;

  const gstPercentage = 18;
  const gstAmount = Math.round(totalAmountBeforeGST * (gstPercentage / 100));

  const totalAmountWithGST = totalAmountBeforeGST + gstAmount;

  const finalTotalAmount =
    saleMode === "Sale By OGCS"
      ? totalAmountWithGST + depositAmount
      : totalAmountWithGST;
      
  return (
    <div className="space-y-6 mt-6 border-t pt-6">
      <div className="space-y-3">
        {/* {saleMode === "Sale By Seller" && (
          <div className="flex justify-between text-lg text-gray-700">
            <span>Visibility Charges:</span>
            <span>₹{visibilityPrice}</span>
          </div>
        )} */}
        {saleMode === "Sale By Seller" && (
  <>
    <div className="flex justify-between text-lg text-gray-700">
      {/* <span>Visibility Charges:</span> */}
      {/* <span>₹{visibilityPrice}</span> */}
    </div>
       {saleMode === "Sale By Seller" && (
          <>
            <div className="flex justify-between text-lg text-gray-700">
              <span>Visibility Charges:</span>
              <span>₹{correctedVisibilityPrice}</span>
            </div>
            {saleProduct === "Hire" && (
              <div className="flex justify-between text-lg text-gray-700">
                <span>
                  Hire Charges ({hireDuration.value} {hireDuration.unit}):
                </span>
                <span>₹{hireAmount}</span>
              </div>
            )}
          </>
        )}

  </>
)}

        <div className="flex justify-between text-lg text-gray-700">
          <span>Power Pack Charges:</span>
          <span>₹{powerPackPrice}</span>
        </div>
        {/* Show Deposit Amount only for Sale By Seller mode */}
        {saleMode === "Sale By OGCS" && (
          <div className="flex justify-between text-lg text-gray-700">
           <span>Deposit Amount ({depositPercentage}%):</span>
            <span>₹{depositAmount}</span>
          </div>
        )}
        <div className="flex justify-between text-lg text-gray-700">
          <span>GST (18%):</span>
          <span>₹{gstAmount}</span>
        </div>
        <div className="flex justify-between text-xl font-semibold text-gray-800">
          <span>Total  :</span>
          <span>₹{totalAmountWithGST}</span>
        </div>
        {saleMode === "Sale By OGCS" && (
          <div className="flex justify-between text-xl font-semibold text-gray-800">
            <span>Final Total  :</span>
            <span>₹{finalTotalAmount}</span>
          </div>
        )}
      </div>

      <div className="flex justify-end mt-6">
        <button
          onClick={() => handleSubmit(finalTotalAmount)}
          className="px-6 py-3 w-full flex justify-center bg-blue-500 text-white rounded-lg hover:bg-blue-600 shadow-md"
        >
          Proceed
        </button>
      </div>
    </div>
  );
}

export default BillComponent;




















// import React from "react";

// function BillComponent({
//   visibilityPrice = 0,
//   powerPackPrice,
//   totalPrice,
//   handleSubmit,
//   ammount,
//   maxquantity,
//   saleMode,
// }) {

  
//   let depositAmount = saleMode === "Sale By OGCS" ? ammount * maxquantity : 0;
//     // Calculate 12% of the depositAmount
//     const depositTax = Math.round(depositAmount * 0.12);
//     depositAmount = depositTax;
//     const totalAmountBeforeGST = visibilityPrice + powerPackPrice ;
  
//     //const gstPercentage = 18;
//     //const gstAmount = Math.round(totalAmountBeforeGST * (gstPercentage / 100));
  
//     // Final total amount including GST
//     const totalAmountWithGST = totalAmountBeforeGST ;//+ gstAmount;

//     const finalTotalAmount = saleMode === "Sale By OGCS" ? totalAmountWithGST + depositAmount : totalAmountWithGST; ;
//   return (
//     <div className="space-y-6 mt-6 border-t pt-6">
//       <div className="space-y-3">
//         {saleMode === "Sale By Seller" && (
//           <div className="flex justify-between text-lg text-gray-700">
//             <span>Visibility Charges:</span>
//             <span>₹{visibilityPrice}</span>
//           </div>
//         )}
//         <div className="flex justify-between text-lg text-gray-700">
//           <span>Power Pack Charges:</span>
//           <span>₹{powerPackPrice}</span>
//         </div>
//         {/* Show Deposit Amount only for Sale By Seller mode */}
//         {saleMode === "Sale By OGCS" && (
//           <div className="flex justify-between text-lg text-gray-700">
//             <span>Deposit Amount:</span>
//             <span>₹{depositAmount}</span>
//           </div>
//         )}
//         <div className="flex justify-between text-lg text-gray-700">
//           <span>GST (18%):</span>
//           {/* <span>₹{gstAmount}</span> */}
//         </div>
//         <div className="flex justify-between text-xl font-semibold text-gray-800">
//           <span>Total  :</span>
//           <span>₹{totalAmountWithGST}</span>
//         </div>
//         {saleMode === "Sale By OGCS" && (
//           <div className="flex justify-between text-xl font-semibold text-gray-800">
//             <span>Final Total  :</span>
//             <span>₹{finalTotalAmount}</span>
//           </div>
//         )}
//       </div>

//       <div className="flex justify-end mt-6">
//         <button
//           onClick={() => handleSubmit(finalTotalAmount)}
//           className="px-6 py-3 w-full flex justify-center bg-blue-500 text-white rounded-lg hover:bg-blue-600 shadow-md"
//         >
//           Proceed
//         </button>
//       </div>
//     </div>
//   );
// }

// export default BillComponent;
